/**
 * Uploads one file to a signed S3 address from the portal-admin Lambda
 * (TASK-630). The browser holds no S3 write rights: the Lambda chooses the key
 * and signs an address for that one key, which works for a few minutes.
 */

/** The file's media type without parameters, as the Lambda accepts it. Empty when the browser does not know it. */
export function mimeTypeOf(file: File): string | undefined {
  const type = file.type.split(';')[0].trim();
  return type || undefined;
}

/**
 * Sends the file with exactly the headers the address was signed with. A
 * different Content-Type makes S3 refuse the upload.
 */
export async function uploadToSignedUrl(url: string, headers: Record<string, string>, file: File): Promise<void> {
  const res = await fetch(url, { method: 'PUT', headers, body: file });
  if (!res.ok) {
    throw new Error(`The file did not upload (S3 answered ${res.status}).`);
  }
}
